<div class="d-flex flex-column">
  <h1>Oops something went wrong!</h1>
  <img src="./assets/ui/png/borken_file.png" class="broken-file">
<!--  <h2 *ngIf="enableDelete">We are really sorry, but we could not process your file.</h2>-->
  <h2>We couldn't find requested file.</h2>
  <div class="button-row">
    <a routerLink="/browse" class="button-blueGDPR">Go back</a>
  </div>
</div>
